import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    const token = sessionStorage.getItem('jwt');
    if (token) {
      // TODO: validazione token JWT
      return true;
    } else {
      this.router.navigate(['/qr-code']);
      return false;
    }
  }
}
